module.exports = __webpack_public_path__ + "img/prepare medicine.ffd74f15.svg";